import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 16px;
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 16px;
  width: 100%;
`

export const GridItem = styled.div<{ $xs: number }>`
  grid-column: span ${({ $xs }) => $xs};
`

export const TitleBlock = styled.div`
  margin-right: 16px;
  width: 100%;
`

export const TitleWrapper = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${myPalette.midnightBlue.main};
  margin-bottom: 4px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const DateText = styled.div`
  font-size: 14px;
  color: ${myPalette.mutedText.main};
`

export const Sum = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${myPalette.midnightBlue.main};
  width: 100%;
  text-align: right;
`
